import React from 'react';
import { Typography } from 'antd';
import ChatContainer from '../components/Chat/ChatContainer';

const { Title } = Typography;

const KardioChatPage: React.FC = () => {
  return (
    <div style={{ height: 'calc(100vh - 112px)', display: 'flex', flexDirection: 'column' }}>
      <Title level={2} style={{ marginBottom: '16px', flexShrink: 0 }}>
        KardioChat
      </Title>
      <div style={{ flex: 1, minHeight: 0 }}>
        <ChatContainer />
      </div>
    </div>
  );
};

export default KardioChatPage;
